export default "__VITE_ASSET__4a0c03a4__"